module.exports = __webpack_public_path__ + "static/media/policypagesheader.4c7001c5.svg";